import api from "../../core/app/api";

export const getProjectsRequest = async () => api.get("projects");

export const getOneProjectRequest = async (slug: string) => api.get(`projects/${slug}`);
